import { Controller, useFormContext } from 'react-hook-form';
import { SelectPicker, SelectPickerProps, Form } from 'rsuite';

interface Option {
  label: string;
  value: string | number;
}

interface Props extends Omit<SelectPickerProps, | 'data' | 'value'> {
  name: string;
  label?: string;
  data: Option[];
}

const SelectInput = ({ name, label, data, searchable = true, ...rest }: Props) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Form.Group controlId={name}>
      {label && <Form.ControlLabel>{label}</Form.ControlLabel>}

      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <SelectPicker
            {...rest}
            data={data}
            value={field.value}
            onChange={(value) => field.onChange(value)}
            style={{ width: 224 }}
            cleanable
            searchable={searchable}
            // placeholder="Select"
          />
        )}
      />

      <Form.ErrorMessage show={!!errors[name]} placement="bottomStart">
        {String(errors[name]?.message) || 'This field is required'}
      </Form.ErrorMessage>
    </Form.Group>
  );
};

export default SelectInput;
